"use client";

import React from "react";
var __jsx = React.createElement;
import { fetchStoryBlockImage } from "@lib/storyblok/services/server-side-service/server-side-service";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useState, useEffect } from "react";
import { MuscleButton } from "../buttons";
import MuscleModal from "../modal";
import { handleLineBreaks } from "@lib/util/string-ops";
import APP_CONFIGURATION from "@lib/app.config";
import useWowOfferTranslations from "@lib/hooks/use-wow-offer-translations";
import ChipDisclaimer from "../chip-disclaimer";
import { useMediaQuery } from "react-responsive";
import useViewportDimensions from "@lib/hooks/use-viewport-dimensions";
import { BREAKPOINTS } from "@lib/constants";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
const processTextWithLinks = function (text) {
  let linkedWords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let linkClassName = arguments.length > 2 ? arguments[2] : undefined;
  if (!linkedWords.length) return text;
  return text.split(" ").map((word, index) => {
    if (linkedWords.includes(word)) {
      return __jsx(React.Fragment, null, __jsx("button", {
        key: index,
        className: cn(linkClassName, "cursor-pointer focus:outline-none"),
        onClick: e => {
          e.preventDefault();
          window.open(APP_CONFIGURATION.config.entityURL, "_blank");
        },
        onTouchStart: e => {
          e.preventDefault();
          window.open(APP_CONFIGURATION.config.entityURL, "_blank");
        }
      }, word), " ");
    }
    return word + " ";
  });
};
export default function UtilityModal(_ref) {
  let {
    open,
    onClose,
    gradient = APP_CONFIGURATION.colors.globals.modal_gradient,
    imageRoutes,
    urlActionFunction,
    linkedWords = []
  } = _ref;
  const t = useTranslations("Shared.UTILITY_MODAL");
  const {
    0: logo,
    1: setLogo
  } = useState(null);
  const {
    0: contentImage,
    1: setContentImage
  } = useState(null);
  const {
    0: entityLogo,
    1: setEntityLogo
  } = useState(null);
  const {
    isAllActive,
    isAnyActive,
    isHotelActive,
    isFlightActive,
    isCarActive,
    utilityModal
  } = useWowOfferTranslations();
  const offerMode = !isAllActive && isAnyActive;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    height,
    width
  } = useViewportDimensions(0.9, isMobile ? 0.9 : 0.9);
  const {
    cssModules
  } = useCssModules();
  const {
    titleClassName,
    titleOfferClassName,
    descriptionClassName,
    descriptionOfferClassName,
    linkClassName,
    chipWowClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.utilityModal) || {};
  useEffect(() => {
    const loadImages = async () => {
      try {
        const [logoUrl, entityLogoUrl, contentImageUrl] = await Promise.all([fetchStoryBlockImage(imageRoutes.logo), fetchStoryBlockImage(imageRoutes.entityLogo), fetchStoryBlockImage(imageRoutes.contentImage)]);
        setLogo(logoUrl);
        setEntityLogo(entityLogoUrl);
        setContentImage(contentImageUrl);
      } catch (error) {
        console.error("Failed to load images:", error);
      }
    };
    loadImages();
  }, [imageRoutes]);
  return __jsx(MuscleModal, {
    preventBackdropClick: true,
    openState: open,
    setOpenState: onClose,
    closeable: true,
    style: {
      background: gradient
    },
    closeButtonLight: true
  }, __jsx("div", {
    className: "w-full flex flex-col px-4  md:px-[30px]"
  }, __jsx("section", {
    id: "content",
    className: cn("w-full max-w-[534px]  flex flex-col", offerMode ? "items-center  md:items-start md:text-left" : "items-center text-center")
  }, logo && __jsx("div", {
    className: "w-[137px] h-[32px] relative"
  }, __jsx(Image, {
    src: logo || "",
    alt: "Platform Logo",
    fill: true,
    className: "object-contain",
    unoptimized: !logo
  })), contentImage && __jsx("div", {
    className: "w-full relative h-[170px] md:h-[267px] my-3 md:my-4"
  }, __jsx(Image, {
    src: contentImage || "",
    alt: "Content Image",
    fill: true,
    className: "",
    unoptimized: !contentImage
  })), __jsx("div", {
    className: cn("w-full max-w-[534px] flex flex-col", offerMode ? "items-start" : "items-center")
  }, offerMode && __jsx(ChipDisclaimer, {
    text: '¡WOW!',
    showIcon: false,
    customTextClassName: chipWowClassName
  }), __jsx("p", {
    className: cn(offerMode ? titleOfferClassName : titleClassName)
  }, handleLineBreaks(utilityModal.title).map((line, index) => __jsx("span", {
    key: index
  }, line, __jsx("br", null)))), __jsx("p", {
    className: cn(offerMode ? descriptionOfferClassName : descriptionClassName)
  }, handleLineBreaks(utilityModal.description).map((line, index) => __jsx("span", {
    key: index
  }, processTextWithLinks(line, linkedWords, linkClassName), __jsx("br", null)))))), __jsx("section", {
    id: "buttons",
    className: "w-full flex flex-col items-center justify-center md:px-6"
  }, __jsx("div", {
    className: cn("w-full flex flex-col items-center justify-center gap-4")
  }, __jsx(MuscleButton, {
    onClick: urlActionFunction,
    onTouchStart: urlActionFunction,
    variant: isMobile ? "solidXL" : "solidMd"
  }, utilityModal.button), __jsx(MuscleButton, {
    onClick: onClose,
    onTouchStart: onClose,
    variant: isMobile ? "outlineXL" : "outlineMd"
  }, utilityModal.link)))));
}